import type React from 'react';

import { observer } from 'mobx-react';

import { useCustomListStore } from 'bz-clinical/controls/settings/clinical-lists/stores/custom-list-store';

import Button from 'bz-core-controls/controls/general/button';
import {
  EDirection,
  useMenuPage,
  useMenuStore,
  useParentMenuPage
} from 'bz-core-controls/controls/general/nested-list-new/stores/menu-store';

import { useAction } from 'bz-utilities/hooks/action';
import useComputed from 'bz-utilities/hooks/computed';

export interface IProps {
  direction: EDirection;
}

const OptionsControlReorder: React.FC<IProps> = observer(({ direction }) => {
  const menu = useMenuStore();
  const page = useMenuPage();
  const parent = useParentMenuPage();
  const store = useCustomListStore();

  const arrow: string = useComputed(() => {
    switch (direction) {
      case EDirection.up:
        return 'fa fa-arrow-up';

      case EDirection.down:
        return 'fa fa-arrow-down';

      default:
        throw new TypeError(`[OptionsControlReorder] - Unknown direction: ${direction}`);
    }
  }, [direction]);

  const reorder = useAction(
    (e: React.MouseEvent): void => {
      e.preventDefault();
      e.stopPropagation();

      parent.onReorder(page.route, direction);
      store.onApply(menu.onExtract());
    },
    [parent, store]
  );

  return (
    <Button small={true} onClick={reorder}>
      <i className={arrow} />
    </Button>
  );
});

export default OptionsControlReorder;
